import { useEffect } from 'react';

import { useDefaultUserStore, usePersistDealExplorerStore } from '../store';
import { Role } from '../types';
import { USER_PERSISTED_KEY } from '../constants';
import { hasCommunityAccess, isLimitedGuestRole } from '../utils';
import {
	useGetCurrentUserErrorHandling,
	useMessengerNotificationsListener,
	usePersistData,
	useRegisterNotifications,
} from '../hooks';

export const useAppRoutes = () => {
	const { data, isLoading } = useGetCurrentUserErrorHandling();

	const currentUser = data?.success ? data.value : undefined;
	const claimsIds = currentUser?.claimsIds;
	const roleId = currentUser?.roleId;
	const modulesIds = currentUser?.modulesIds || [];

	const isLimitedAccess = isLimitedGuestRole(roleId);
	const isAdmin = roleId === Role.Admin;
	const isShowQuickStart = !isLimitedAccess && hasCommunityAccess(claimsIds);

	const { getPersistedValue, newUserReset } =
		usePersistData(USER_PERSISTED_KEY);
	const resetFiltersState = usePersistDealExplorerStore(
		state => state.resetFiltersState,
	);
	const { setUser } = useDefaultUserStore();

	useMessengerNotificationsListener();
	useRegisterNotifications();

	useEffect(() => {
		if (!data?.success || !data.value) {
			setUser(null);
			return;
		}
		setUser(data.value);

		const storedUserId = getPersistedValue('user', 'id');
		if (storedUserId && storedUserId === data.value.userId) {
			return;
		}

		newUserReset(data.value.userId);
		resetFiltersState();
	}, [data]);

	const bootstrapFailed = !!data && (!data.success || !data.value);

	const needsOnboarding =
		!bootstrapFailed &&
		!!currentUser &&
		!isLimitedAccess &&
		!currentUser.isCampaignFieldsSet;

	return {
		isGlobalLoading: isLoading,
		bootstrapFailed,
		needsOnboarding,
		isCampaignFieldsSet: currentUser?.isCampaignFieldsSet,
		claimsIds,
		modulesIds,
		isLimitedAccess,
		isAdmin,
		isShowQuickStart,
	};
};
